/**
 * After Remind me / Not interested: hide the tip, keep WhatsApp / phone /
 * email / demo. First-try empties and first-success already have their own
 * human row; this is for Home / chrome PrimaryNudge.
 */

const KEY_PREFIX = 'oms_ge_keep_human_after_tip_dismiss_'
const memory = new Map()

function storageKey(venueId) {
  return `${KEY_PREFIX}${String(venueId)}`
}

export function normalizeGrowthEngineKeepHumanPayload(payload = {}) {
  return {
    featureId: payload.featureId || null,
    featureLabel: payload.featureLabel || payload.featureName || null,
  }
}

function writeSession(venueId, value) {
  if (typeof sessionStorage === 'undefined') return
  try {
    if (value == null) {
      sessionStorage.removeItem(storageKey(venueId))
      return
    }
    sessionStorage.setItem(storageKey(venueId), JSON.stringify(value))
  } catch {
    // Private mode / quota — memory Map still works for this session.
  }
}

function readSession(venueId) {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(storageKey(venueId))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return normalizeGrowthEngineKeepHumanPayload(parsed)
  } catch {
    return null
  }
}

export function markGrowthEngineKeepHumanAfterTipDismiss(
  venueId,
  payload = {},
) {
  if (!venueId) return null
  const value = normalizeGrowthEngineKeepHumanPayload(payload)
  memory.set(String(venueId), value)
  writeSession(venueId, value)
  return value
}

export function readGrowthEngineKeepHumanAfterTipDismiss(venueId) {
  if (!venueId) return null
  const key = String(venueId)
  if (memory.has(key)) return memory.get(key)
  const fromSession = readSession(venueId)
  if (fromSession) {
    memory.set(key, fromSession)
    return fromSession
  }
  return null
}

export function clearGrowthEngineKeepHumanAfterTipDismiss(venueId) {
  if (!venueId) return
  memory.delete(String(venueId))
  writeSession(venueId, null)
}

/** True while the tip is up, or after cool-off while contacts remain. */
export function isGrowthEngineHelpShowing(tipShowing, keptHuman) {
  return Boolean(tipShowing || keptHuman)
}

/** Test helper */
export function __resetGrowthEngineKeepHumanAfterTipDismissForTests() {
  memory.clear()
  if (typeof sessionStorage === 'undefined') return
  try {
    const keys = []
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i)
      if (key && key.startsWith(KEY_PREFIX)) keys.push(key)
    }
    keys.forEach(key => sessionStorage.removeItem(key))
  } catch {
    // ignore
  }
}
